// Global Types
import { ResetStateAction } from 'services/auth/types';

// Global Constants
// @ts-ignore
import { SET_CURRENT_ORGANIZATION_ID } from 'services/currentOrganizationId/constants';
import { RESET_STATE } from 'services/auth/constants';

// Local Types
import {
    HarvestPrintPropertiesState,
    HarvestPrintPropertiesTypes
} from './types';

// Local Constants
import { HARVEST_PRINT_PROPERTIES_SET } from './constants';

export const initialState: HarvestPrintPropertiesState = {
    harvestBinSuitabilities: {},
    harvestGrowingMethods: {},
    harvestLocations: {},
    harvestPalletTypes: {},
    harvestStorageTypes: {},
    harvestSubmissionProfiles: {}
};

export default function (
    state: HarvestPrintPropertiesState = initialState,
    action: HarvestPrintPropertiesTypes | ResetStateAction
): HarvestPrintPropertiesState {
    switch (action.type) {
        case HARVEST_PRINT_PROPERTIES_SET:
            return action.payload;
        case SET_CURRENT_ORGANIZATION_ID:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
